const config = window.CODEBRUH_ADMIN_CONFIG || {};
export const SERVER_URL = (config.serverUrl || "http://localhost:5001").replace(/\/$/, "");
export const API_BASE_URL = (config.apiBaseUrl || `${SERVER_URL}/api`).replace(/\/$/, "");
